import React from "react";
import {
  Button,
  Form,
  Table,
  Dropdown,
  InputGroup,
  FormControl,
} from "react-bootstrap";

import { FaSearch } from "react-icons/fa";

const Dashboard: React.FC = () => {
  const stats = [
    "Total Algo Created",
    "Completed Backtests",
    "+100% Yr",
    "+2.0 Profit Factor",
    "+2.0 Sharpe Ratio",
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="h4 mb-1">Dashboard</h2>
          <p className="text-muted small mb-0">Overview of algorithms and backtests</p>
        </div>
      </div>

      <div className="d-flex gap-3 mb-4 flex-wrap">
        {stats.map((title, index) => (
          <div key={index} className="gogi-stat-card">
            <div className="stat-label">{title}</div>
            <div className="stat-value">{Math.floor(Math.random() * 5000)}</div>
          </div>
        ))}
      </div>

      <InputGroup className="mb-4" style={{ maxWidth: 360 }}>
        <FormControl placeholder="Search algorithms…" />
        <Button variant="outline-secondary">
          <FaSearch />
        </Button>
      </InputGroup>

      <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
        <Button variant="outline-secondary" size="sm">Statistics</Button>
        <Button variant="outline-secondary" size="sm">Algos</Button>
        <Button variant="outline-secondary" size="sm">Smart Algos</Button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h3 className="h5 fw-semibold mb-0">
          Algorithms <span className="text-muted fw-normal small">6,560,067 results</span>
        </h3>
        <div className="d-flex gap-2">
          <Button variant="outline-secondary" size="sm">Export</Button>
          <Dropdown>
            <Dropdown.Toggle variant="outline-secondary" size="sm">
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="#">View Report</Dropdown.Item>
              <Dropdown.Item href="#">Download CSV</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
        <span className="text-muted small fw-medium">Filter by:</span>
        <Button variant="outline-secondary" size="sm">Profit/Loss</Button>
        <Button variant="outline-secondary" size="sm">Asset Class</Button>
        <Button variant="outline-secondary" size="sm">Broker</Button>
        <Button variant="outline-secondary" size="sm">Profit Rate</Button>
        <Button variant="link" size="sm" className="text-decoration-none">
          More options
        </Button>
      </div>

      <Form className="mb-3" style={{ maxWidth: 360 }}>
        <Form.Control type="search" placeholder="Search…" size="sm" />
      </Form>

      <div className="gogi-table-wrap">
        <Table hover responsive className="mb-0">
          <thead>
            <tr>
              <th>Algo</th>
              <th>Date Range</th>
              <th>Starting Balance</th>
              <th>Profit/Loss</th>
              <th>Profit Rate</th>
              <th>Ending Balance</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="gogi-mono">+31_G023984</td>
              <td>Apr 23, 2021</td>
              <td>$500.00</td>
              <td className="text-success">+$2300 / 34%</td>
              <td>1.2</td>
              <td>$500.00</td>
              <td>
                <span className="badge bg-success">Completed</span>
              </td>
              <td className="text-muted">Apr 23, 2021</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Dashboard;
